import gql from 'graphql-tag';

export const CMS_SEARCH_PROPERTIES_BY_NAME = gql`
  query search(
    $query: String
    $pageNumber: Int
    $pageSize: Int
    $publishedStatus: NodePublishedFilter = PUBLISHED
  ) {
    search(
      query: $query
      pageSize: $pageSize
      pageNumber: $pageNumber
      publishedStatus: $publishedStatus
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      edges {
        node {
          ... on Property {
            name
            slug
            id
            city {
              name
            }
            landlord {
              id
            }
          }
        }
      }
    }
  }
`;
